var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllVehicles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "all-vehicles",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_19",
    "data-name": "Rect\\xE1ngulo 19",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "steering",
    d: "M10.88,15.837a5.7,5.7,0,0,0,4.957-4.957H13.688a3.649,3.649,0,0,1-2.808,2.808v2.149M8.731,7.3H11.6l2.149,2.149h2.092a5.691,5.691,0,0,0-1.9-3.582,5.51,5.51,0,0,0-3.775-1.433A5.51,5.51,0,0,0,6.388,5.865a5.691,5.691,0,0,0-1.9,3.582H6.582L8.731,7.3m.716,8.539V13.688A3.649,3.649,0,0,1,6.639,10.88H4.49a5.5,5.5,0,0,0,1.626,3.3,5.7,5.7,0,0,0,3.331,1.662M10.164,3a6.9,6.9,0,0,1,5.05,2.113,6.9,6.9,0,0,1,2.113,5.05,6.9,6.9,0,0,1-2.113,5.05,6.9,6.9,0,0,1-5.05,2.113,6.9,6.9,0,0,1-5.05-2.113A6.9,6.9,0,0,1,3,10.164a6.9,6.9,0,0,1,2.113-5.05A6.9,6.9,0,0,1,10.164,3Z",
    transform: "translate(2 2)",
    fill: "#f5f5f5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllVehicles);
export default __webpack_public_path__ + "static/media/all-vehicles.6a238735527b6ef8418a9b12ab7d4682.svg";
export { ForwardRef as ReactComponent };